import * as React from 'react';
import Button from 'components/ButtonDeprecated';
import ConfirmDevice from 'auth/components/ConfirmDevice';
import Device from 'entities/Device';
// @ts-ignore
import DeviceStore from 'stores/DeviceStore';
import PasswordStrengthField, { MIN_PASSWORD_LENGTH } from 'components/PasswordStrengthField';
import ToastActions from 'actions/ToastActions';
// @ts-ignore
import UserActions from 'user/UserActions';

type Props = {
  onSave: () => void;
  onNeedsDeviceConfirmation: () => void;
};

type State = {
  canSubmit: boolean;
  needsDeviceConfirmation: boolean;
  needsConfirmationErrorCode?: string;
  password: string;
};

class PasswordForm extends React.Component<Props, State> {
  state = {
    canSubmit: false,
    needsDeviceConfirmation: false,
    needsConfirmationErrorCode: undefined,
    password: '',
  };

  submit = () => {
    const onSuccess = () => {
      ToastActions.showSuccessToast('Saved!');
      this.props.onSave();
    };

    const onFailure = (error: any) => {
      // When a user initiates an account merge while logged into their (now obsoleted) source
      // account, we try to log them into their target account. However, because of login confirmation,
      // they may need to confirm their target account device, which is conveyed by a 403 error.
      if (error.statusCode === 403) {
        this.setState({ needsDeviceConfirmation: true, needsConfirmationErrorCode: error.code });
        this.props.onNeedsDeviceConfirmation();
      } else {
        ToastActions.showAPIError(error);
      }
    };

    UserActions.createPassword(this.state.password).then(onSuccess, onFailure);
  };

  handlePasswordUpdated = (password: string) => {
    this.setState({ password });
  };

  render() {
    const { needsDeviceConfirmation } = this.state;

    if (needsDeviceConfirmation) {
      const { needsConfirmationErrorCode } = this.state;

      // This mimics the logic in UserActions.signInWithDevice
      // https://github.com/remind101/r101-frontend/blob/0ac1ad3aad945452a276c36da31cb18aa846266f/src/user/UserActions.js#L43
      const devices = DeviceStore.getDevices();
      const emailOrPhoneDevice = devices.find(
        (d: Device) => d.getType() === 'sms' || d.getType() === 'email'
      );
      const deviceType = emailOrPhoneDevice.getType() === 'email' ? 'email' : 'phone';

      return (
        <ConfirmDevice
          deviceType={deviceType}
          uid={emailOrPhoneDevice.getEndpoint()}
          // At this point, a password should have been set already
          needsPassword={false}
          needsConfirmationErrorCode={needsConfirmationErrorCode}
        />
      );
    } else {
      return (
        <div className="PasswordForm">
          <form
            data-test="password-form"
            onSubmit={e => {
              e.preventDefault();
              this.submit();
            }}>
            <PasswordStrengthField
              name="password"
              label="Password"
              onPasswordUpdated={this.handlePasswordUpdated}
            />
            <Button
              data-test="submit-password-button"
              disabled={this.state.password.length < MIN_PASSWORD_LENGTH}
              className="PasswordForm-Submit"
              type="submit"
              eventElementName="PasswordForm-Submit">
              {'Save'}
            </Button>
          </form>
        </div>
      );
    }
  }
}

export default PasswordForm;
